import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const MemoriesHeroContentWrapper = styled.div`
  margin: 0 var(--p-content);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 1rem;
    flex-direction: column;
  }
`

export const MemoriesHeroContent = styled.div<{ isDragActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;
  position: relative;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
    order: 1;
  }

  outline: none;
  border: 2px solid transparent;
  ${({ isDragActive }) =>
    isDragActive &&
    `
      box-sizing: initial;
      border: 2px dashed var(--c-blue300);
      background-color: var(--c-blue100);
    `}
`

export const MemoriesHeroContentBox = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 43px 64px;
  margin-top: 2rem;
  margin-bottom: 2rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
  }

  @media ${BREAKPOINTS.LG.max} {
    padding: 20px;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding: 20px;

    &:before {
      top: -1rem;
      bottom: -30%;
      right: -20%;
    }
  }
`

export const ShareItemsContainer = styled.div`
  margin-top: 0.25rem;
  width: 100%;
`

export const SMemoriesHeroGallery = styled.div<{ isUploading?: boolean }>`
  right: 0;
  top: 0;
  width: 47%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ isUploading }) =>
    isUploading &&
    `
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    background-color: var(--c-gray300);
    border: 2px solid var(--c-blue100);
    & p {
      margin-bottom: 10px;
    } `}

  & > div {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-position: center 15%;
  }

  @media ${BREAKPOINTS.MD.max} {
    order: 2;
    width: 100%;
    margin-bottom: 1rem;
  }
`

export const SMemoriesRedo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 0.25rem;
`

export const SUploadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 24rem;
  padding: 24px;
  & > div {
    margin-bottom: 1rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    min-height: auto;
  }
`

export const SInstructiveText = styled(Text)`
  margin-left: calc(2 * var(--p-button));
  font-weight: bold;
  color: var(--c-blue500);
  cursor: default;
  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`
